import type { SVGAttributes } from 'react';
import type { ChakraProps } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';

const Svg = chakra('svg');

type Props = Omit<SVGAttributes<SVGElement>, keyof ChakraProps> & ChakraProps;

export const NotaryIllustration = (props: Props) => (
  <Svg
    width={179}
    height={173}
    viewBox='0 0 179 173'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g clipPath='url(#clip0_3390_31586)'>
      <circle cx='86.1514' cy='91' r='63' fill='#F9EFE2' />
      <circle cx='92.1514' cy='81' r='62.25' stroke='#F0D4B2' strokeWidth='1.5' />
      <mask
        id='mask0_3390_31586'
        maskUnits='userSpaceOnUse'
        x='23'
        y='-21'
        width='127'
        height='175'>
        <path
          d='M86.0757 153.651C120.911 153.651 149.151 125.456 149.151 90.675V-21H23V90.675C23 125.456 51.2399 153.651 86.0757 153.651Z'
          fill='#F9EFE2'
        />
      </mask>
      <g mask='url(#mask0_3390_31586)'>
        <path
          d='M52.6258 81.7464L69.0271 75.6984L105.96 73.3319L128.457 81.0125C135.251 83.3319 139.863 89.6763 139.985 96.8714L141.234 170.386C117.995 176.003 66.3298 180.997 38.4224 166.017L41.6383 96.7787C41.9527 90.0084 46.2817 84.0858 52.6258 81.7464Z'
          fill='#50B2C2'
        />
        <path
          d='M69.0271 75.6984L105.96 73.3319L90.8136 128.152H85.6263L69.0271 75.6984Z'
          fill='#F9EFE2'
        />
        <path
          d='M72.3773 72.8118V66.6604L100.426 51.7462C100.767 59.1029 101.044 66.3122 101.411 70.1685L87.4418 83.8383L72.3773 72.8118Z'
          fill='#EEC7B1'
        />
        <path
          d='M87.4419 83.8383L72.3773 72.8118L69.0271 75.6204L81.3728 89.7157L87.4419 83.8383Z'
          fill='white'
        />
        <path
          d='M101.411 70.1685L87.4418 83.8383L94.2371 89.0915L105.96 73.3319L101.411 70.1685Z'
          fill='white'
        />
        <g filter='url(#filter0_f_3390_31586)'>
          <ellipse cx='82.7214' cy='65.8422' rx='9.33704' ry='3.01669' fill='#E9BC9B' />
        </g>
        <path
          d='M64.8811 63.7493C68.5268 67.3492 83.5437 68.7796 91.6435 65.8942C96.9345 64.0093 100.842 60.9546 100.723 58.3004C100.497 53.334 100.263 47.8005 99.9649 42.8579C99.9649 42.8579 103.689 42.5739 103.055 38.6399C102.422 34.706 99.5411 37.3006 99.5411 37.3006C99.3458 34.8524 99.209 33.3451 98.9522 31.719C97.2914 21.204 89.5314 15.7935 82.2042 15.7935C74.877 15.7935 68.0804 17.4417 63.0002 26.1239C59.6786 31.912 60.8757 59.7941 64.8811 63.7493Z'
          fill='#EEC7B1'
        />
        <g filter='url(#filter1_f_3390_31586)'>
          <ellipse cx='70.8404' cy='49.6144' rx='4.25354' ry='4.26498' fill='#E9BC9B' />
        </g>
        <g filter='url(#filter2_f_3390_31586)'>
          <ellipse cx='85.5721' cy='47.742' rx='4.25354' ry='4.26498' fill='#E9BC9B' />
        </g>
        <path
          d='M54.3365 24.1008C53.9599 27.4992 56.596 32.4081 61.1151 37.3169C62.3203 34.9003 63.3748 30.0166 63.7514 27.8768C64.128 30.1425 70.9066 30.8977 89.7362 19.9471C94.6319 22.5904 98.3978 27.4992 99.5276 37.3169C100.657 34.5478 102.691 26.8951 101.787 18.4367C100.657 7.86379 92.3724 8.619 89.7362 11.2622C88.8575 9.37421 86.1963 5.59816 82.581 5.59816C78.0619 5.59816 54.7131 20.7023 54.3365 24.1008Z'
          fill='#EFB100'
        />
        <path
          d='M76.527 50.0658C76.527 50.0658 75.2233 53.7049 72.1134 55.3645C69.0035 57.0241 65.2649 56.0757 65.2649 56.0757C65.2649 56.0757 66.5685 52.4365 69.6784 50.7769C72.7884 49.1174 76.527 50.0658 76.527 50.0658Z'
          fill='#EFB100'
        />
        <path
          d='M76.5586 50.0562C76.5586 50.0562 78.9183 53.2648 82.4791 53.9831C86.0399 54.7013 89.4534 52.6573 89.4534 52.6573C89.4534 52.6573 87.0937 49.4487 83.533 48.7305C79.9722 48.0122 76.5586 50.0562 76.5586 50.0562Z'
          fill='#EFB100'
        />
        <ellipse
          rx='0.726229'
          ry='1.97641'
          transform='matrix(0.996174 -0.0873883 0.0869238 0.996215 69.3376 41.559)'
          fill='#014558'
        />
        <ellipse
          rx='0.726229'
          ry='1.97641'
          transform='matrix(0.996174 -0.0873883 0.0869238 0.996215 87.4141 40.0486)'
          fill='#014558'
        />
        <ellipse opacity='0.45' cx='70.1164' cy='44.2572' rx='5.29099' ry='2.1845' fill='#F9EFE2' />
        <path
          d='M73.1304 48.099C72.7538 49.2318 75.1999 49.9265 76.7561 49.9265L76.1432 40.5469C75.2645 42.6866 73.4317 47.1927 73.1304 48.099Z'
          fill='#EEC6B0'
        />
        <path
          d='M76.7561 49.9265C75.1999 49.9265 72.7538 49.2318 73.1304 48.099C73.4317 47.1927 75.2645 42.6866 76.1432 40.5469'
          stroke='#014558'
          strokeWidth='0.75'
        />
        <path d='M74.6553 44.2318L76.4838 44.2318' stroke='#014558' strokeWidth='0.75' />
        <ellipse opacity='0.45' cx='81.7878' cy='44.2572' rx='5.29099' ry='2.1845' fill='#F9EFE2' />
        <path
          d='M65.2763 35.0513C66.6264 33.4337 70.0759 32.6564 72.3775 33.8453'
          stroke='#EFB100'
          strokeWidth='5'
        />
        <path
          d='M90.8347 33.595C89.4847 31.9774 86.0351 31.2001 83.7336 32.389'
          stroke='#EFB100'
          strokeWidth='5'
        />
        <path
          d='M86.975 57.2602C86.2488 59.0286 84.5888 59.7048 83.1364 59.6528'
          stroke='#014558'
          strokeWidth='0.75'
        />
        <mask id='mask1_3390_31586' maskUnits='userSpaceOnUse' x='69' y='73' width='37' height='60'>
          <path
            d='M69.0271 75.6984L105.96 73.3319L90.8136 128.152L88.3431 132.486L85.6263 128.152L69.0271 75.6984Z'
            fill='#E9BC9B'
          />
        </mask>
        <g mask='url(#mask1_3390_31586)'>
          <path
            d='M82.3583 88.7794L87.4418 83.8383L93.0441 88.2073L88.0643 94.0847L96.1045 131.949L88.0643 138.659L80.076 131.949L88.0643 94.0847L82.3583 88.7794Z'
            fill='#D8601E'
          />
        </g>
        <path
          d='M120.874 78.4291L105.96 73.3319L88.3237 132.521L109.695 107.764L104.923 103.603H110.94L120.874 78.4291Z'
          fill='#42A0AF'
        />
        <path
          d='M56.5777 80.3015L69.081 75.672L88.3694 132.532L66.8485 108.7L69.6496 104.539L65.2923 104.539L56.5777 80.3015Z'
          fill='#42A0AF'
        />
        <ellipse
          rx='10.4865'
          ry='2.17361'
          transform='matrix(0.930944 -0.365162 0.363466 0.931608 113.572 116.348)'
          fill='#014558'
        />
        <path
          d='M110.03 85.7785L123.27 119.965L107.222 126.6L106.692 116.393C104.61 117.053 100.022 117.485 97.9872 116.998C96.3486 115.627 92.7336 106.177 95.2898 100.25C97.7669 98.4316 104.056 97.1318 107.919 98.1914C107.919 98.1914 106.76 92.0745 107.319 90.2686C107.79 88.3918 108.613 86.6956 110.03 85.7785Z'
          fill='#EEC6B0'
        />
        <line
          y1='-0.5'
          x2='6.96002'
          y2='-0.5'
          transform='matrix(0.983785 -0.179352 0.17842 0.983954 94.3561 104.931)'
          stroke='#014558'
        />
        <line
          y1='-0.5'
          x2='6.96002'
          y2='-0.5'
          transform='matrix(0.983785 -0.17935 0.178422 0.983954 94.9633 109.636)'
          stroke='#014558'
        />
        <line
          y1='-0.5'
          x2='6.96002'
          y2='-0.5'
          transform='matrix(0.983785 -0.179352 0.17842 0.983954 96.2235 114.085)'
          stroke='#014558'
        />
        <path
          d='M106.687 116.398C107.722 116.016 108.242 115.738 109.073 115.149'
          stroke='#014558'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M123.363 112.762C123.227 113.985 119.393 116.399 114.362 118.372C109.304 120.357 104.833 121.19 103.939 120.362L120.5 164.224C120.714 163.825 129.866 148.154 134.713 140.507L123.363 112.762Z'
          fill='#50B2C2'
        />
        <ellipse cx='122.575' cy='119.494' rx='1.03745' ry='1.04024' fill='#006D86' />
        <path
          d='M123.237 112.485L131.689 133.146M103.925 120.12L116.454 153.482'
          stroke='#014558'
          strokeWidth='0.75'
        />
        <path
          d='M126.654 120.84C127.09 121.959 123.073 124.58 117.682 126.694C112.29 128.809 107.566 129.617 107.129 128.499'
          stroke='#014558'
          strokeWidth='0.75'
        />
        <path d='M59.4826 173.299L58.4451 120.247' stroke='#014558' strokeWidth='0.75' />
        <path
          opacity='0.2'
          d='M61.1425 37.2356C60.6584 33.196 60.1258 24.5759 61.8687 22.4122C64.0474 19.7076 83.3439 10.9176 86.2488 12.0618C88.1488 12.8103 90.1738 17.8352 89.828 19.9676C91.021 16.7429 93.459 12.946 95.897 13.7262C98.3351 14.5064 101.655 19.8116 99.58 37.0796'
          stroke='#965808'
          strokeWidth='0.75'
        />
        <path
          opacity='0.2'
          d='M63.7361 27.8214C69.4421 28.3936 80.9059 17.8352 84.3295 17.263C87.0683 16.8053 89.1018 18.8407 89.7761 19.9156C91.5398 17.055 93.3553 15.7027 95.2746 16.0147C97.1939 16.3268 99.995 18.9274 99.5281 36.8195'
          stroke='#965808'
          strokeWidth='0.75'
        />
        <path d='M88.3496 132.443L89.7761 175.795' stroke='#014558' strokeWidth='0.75' />
        <ellipse cx='92.8884' cy='142.716' rx='2.0749' ry='2.08047' fill='#006D86' />
      </g>
      <circle cx='171' cy='136' r='8' fill='#50B2C2' />
    </g>
    <defs>
      <filter
        id='filter0_f_3390_31586'
        x='71.3844'
        y='60.8255'
        width='22.6741'
        height='10.0334'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='1' result='effect1_foregroundBlur_3390_31586' />
      </filter>
      <filter
        id='filter1_f_3390_31586'
        x='64.5868'
        y='43.3495'
        width='12.5071'
        height='12.53'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='1' result='effect1_foregroundBlur_3390_31586' />
      </filter>
      <filter
        id='filter2_f_3390_31586'
        x='79.3186'
        y='41.4771'
        width='12.5071'
        height='12.53'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='1' result='effect1_foregroundBlur_3390_31586' />
      </filter>
      <clipPath id='clip0_3390_31586'>
        <rect width='179' height='173' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);
